class CustomError extends Error {
  constructor(err) {
    super(err.message);
    this.description = err.message;
    this.type = err.type;
  }
}

export default CustomError;
